// "use client";

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Container,
//   Flex,
//   FormControl,
//   Heading,
//   Input,
//   Select,
//   Tag,
//   TagCloseButton,
//   TagLabel,
//   Text,
//   VStack,
//   Wrap,
//   WrapItem,
//   SimpleGrid,
//   useColorModeValue,
//   Image,
//   Badge,
//   InputGroup,
//   InputLeftElement,
//   Divider,
//   IconButton,
//   Tooltip,
//   Center,
//   Skeleton,
//   SkeletonCircle,
//   SkeletonText,
// } from "@chakra-ui/react";
// import { SearchIcon, StarIcon } from "@chakra-ui/icons";
// import { fetchSuggestionsAsync, selectSuggestions } from "./SuggestionsSlice";
// import {
//   fetchJobsByKeywordsAsync,
// } from "../jobSearchByKeywordSlice.js/jobSearchByKeywordSlice";
// import {
//   fetchPublicCoreLocationsAsync,
//   selectPublicCoreLocations,
// } from "../FetchLocationSlice/FetchLocationSlice";

// const JobListingSkeleton = () => (
//   <Box
//     borderWidth={1}
//     borderradius="lg"
//     overflow="hidden"
//     boxShadow="md"
//     bg="white"
//   >
//     <Flex p={6}>
//       <SkeletonCircle size="16" mr={4} />
//       <Box flex={1}>
//         <SkeletonText
//           mt="4"
//           noOfLines={1}
//           spacing="4"
//           skeletonHeight="3"
//           width="70%"
//         />
//         <SkeletonText
//           mt="4"
//           noOfLines={1}
//           spacing="4"
//           skeletonHeight="2"
//           width="50%"
//         />
//         <SkeletonText
//           mt="4"
//           noOfLines={1}
//           spacing="4"
//           skeletonHeight="2"
//           width="60%"
//         />
//         <SkeletonText
//           mt="4"
//           noOfLines={1}
//           spacing="4"
//           skeletonHeight="2"
//           width="40%"
//         />
//         <Wrap mt="4">
//           <Skeleton height="24px" width="60px" />
//           <Skeleton height="24px" width="60px" />
//           <Skeleton height="24px" width="60px" />
//         </Wrap>
//       </Box>
//     </Flex>
//     <Divider />
//     <Flex justifyContent="space-between" p={4}>
//       <Skeleton height="32px" width="100px" />
//       <Skeleton height="32px" width="100px" />
//     </Flex>
//   </Box>
// );

// function JobSearch() {
//   const dispatch = useDispatch();
//   const coreLocation = useSelector(selectPublicCoreLocations);
//   const response = useSelector(selectSuggestions);
//   // const results = useSelector(selectJobsByKeywords);
//   // const [keyword, setKeyword] = useState("");
//   const [selectedTitles, setSelectedTitles] = useState([]);
//   const [experience, setExperience] = useState("");
//   // const [locations, setLocations] = useState([]);
//   const [isSearched, setIsSearched] = useState(false);
//   const [isInputFocused, setIsInputFocused] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const location = useLocation();

//   const initialKeyword = location.state?.keyword || "";
//   const initialLocationUUID = location.state?.locationUUID || "";

//   const [keyword, setKeyword] = useState(initialKeyword);
//   const [locations, setLocations] = useState(
//     initialLocationUUID ? [initialLocationUUID] : []
//   );

//   useEffect(() => {
//     if (initialLocationUUID && !locations.includes(initialLocationUUID)) {
//       setLocations((prevLocations) => [...prevLocations, initialLocationUUID]);
//     }
//   }, [initialLocationUUID, locations]); // Empty dependency array means this effect runs once when the component mounts
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (location.state) {
//       navigate("/job-search", { replace: true, state: null }); // Clear state after use
//     }
//   }, [location.state, navigate]);

//   useEffect(() => {
//     dispatch(fetchPublicCoreLocationsAsync());
//     if (keyword) {
//       dispatch(fetchSuggestionsAsync({ keyword }));
//     }
//   }, [keyword, dispatch]);

//   const handleLocationSelect = (e) => {
//     const selectedLocation = e.target.value;
//     if (selectedLocation && !locations.includes(selectedLocation)) {
//       setLocations((prevLocations) => [...prevLocations, selectedLocation]);
//     }
//     setIsSearched(false);
//   };

//   const handleChange = (e) => {
//     setKeyword(e.target.value);
//     setIsSearched(false);
//     // Optionally, you can save the updated keyword to localStorage on change
//     localStorage.setItem("keyword", e.target.value);
//   };

//   const handleSelect = (title) => {
//     if (!selectedTitles.includes(title)) {
//       setSelectedTitles([...selectedTitles, title]);
//     }
//   };

//   const handleExperienceChange = (e) => {
//     setExperience(e.target.value);
//     setIsSearched(false);
//   };

//   const removeLocation = (location) => {
//     setLocations(locations.filter((loc) => loc !== location));
//   };

//   const removeTitle = (title) => {
//     setSelectedTitles(selectedTitles.filter((t) => t !== title));
//   };

//   const findJsUuids = () => {
//     return response
//       .filter(
//         (item) =>
//           item.uuid.startsWith("js") && selectedTitles.includes(item.title)
//       )
//       .map((item) => item.uuid.replace(/^js_/, ""));
//   };

//   const findJtUuids = () => {
//     return response
//       .filter(
//         (item) =>
//           item.uuid.startsWith("jt") && selectedTitles.includes(item.title)
//       )
//       .map((item) => item.uuid.replace(/^jt_/, ""));
//   };

//   const findCnUuids = () => {
//     return response
//       .filter(
//         (item) =>
//           item.uuid.startsWith("cn") && selectedTitles.includes(item.title)
//       )
//       .map((item) => item.uuid.replace(/^cn_/, "")); // Remove 'cn_' prefix
//   };
//   const [result, setResult] = useState([]); // Store search results

//   const categorizeAndSend = () => {
//     setResult([]); // Clear previous results
//     const jsUuids = findJsUuids(); // Skill UUIDs
//     const jtUuids = findJtUuids(); // Title UUIDs
//     const cnUuids = findCnUuids(); // Company UUIDs with 'cn_' prefix removed

//     // Only include non-empty fields in the payload
//     const payload = {
//       ...(experience ? { experience } : {}),
//       ...(locations.length ? { locations } : {}),
//       ...(jsUuids.length ? { skills: jsUuids } : {}),
//       ...(jtUuids.length ? { titles: jtUuids } : {}),
//       ...(cnUuids.length ? { company: cnUuids } : {}),
//     };

//     // Ensure at least one filter is applied
//     if (Object.keys(payload).length === 0) {
//       console.log("No filters applied. Please select at least one condition.");
//       return;
//     }

//     setIsLoading(true);

//     dispatch(fetchJobsByKeywordsAsync(payload))
//       .then((response) => {
//         setIsLoading(false);
//         setIsSearched(true);
//         setIsInputFocused(false);

//         // Assuming the response contains the results you want to display
//         const jobs = response.payload; // Adjust this if your response structure is different
//         setResult(jobs); // Set the new jobs list
//       })
//       .catch(() => {
//         setIsLoading(false);
//       });
//   };

//   const bgColor = useColorModeValue("white", "gray.800");
//   const accentColor = "blue.500";
//   const hoverAccentColor = "blue.600";

//   return (
//     <Box bg="gray.50" minH="100vh">
//       {/* <Dummy /> */}
//       <Container maxW="8xl" py={8}>
//         {/* Header Section */}
//         <Box
//           position="relative"
//           mb={8}
//           borderradius="xl"
//           overflow="hidden"
//           p={8}
//           style={{
//             background:
//               "linear-gradient(340deg, rgba(119, 161, 211, 0.2),rgba(121, 203, 202,0.1),rgba(254, 234, 234, 1))",
//           }}
//         >
//           <Flex
//             position="relative"
//             zIndex={1}
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <VStack align="flex-start" spacing={2}>
//               <Heading
//                 as="h1"
//                 size={{ base: "xl", md: "2xl" }}
//                 color="gray.800"
//                 maxW="xl"
//                 className="text-left"
//               >
//                 Find Your <span className="text-fontBlue">Dream Job</span> Here
//               </Heading>
//               <Text color="gray.600" fontSize="lg">
//                 Discover opportunities that match your career goals
//               </Text>
//             </VStack>
//           </Flex>
//         </Box>

//         {/* Search Section */}
//         <Box bg={bgColor} p={6} borderradius="xl" boxShadow="sm" mb={8}>
//           <VStack spacing={6}>
//             <Flex
//               gap={4}
//               w="full"
//               flexDirection={{ base: "column", md: "row" }}
//             >
//               <InputGroup size="lg" flex={{ base: "auto", md: 2 }}>
//                 <InputLeftElement pointerEvents="none">
//                   <SearchIcon color="gray.400" />
//                 </InputLeftElement>
//                 <Input
//                   placeholder="Job title or keyword"
//                   value={keyword}
//                   onChange={handleChange}
//                   onFocus={() => setIsInputFocused(true)}
//                   borderradius="lg"
//                   _focus={{ borderColor: accentColor, boxShadow: "none" }}
//                 />
//               </InputGroup>
//               <FormControl flex={{ base: "auto", md: 1 }}>
//                 <Select
//                   size="lg"
//                   placeholder="Experience"
//                   value={experience}
//                   onChange={handleExperienceChange}
//                   borderradius="lg"
//                   _focus={{ borderColor: accentColor, boxShadow: "none" }}
//                 >
//                   {Array.from({ length: 10 }, (_, i) => i + 1).map((year) => (
//                     <option key={year} value={year}>
//                       {year} {year > 1 ? "Years" : "Year"}
//                     </option>
//                   ))}
//                 </Select>
//               </FormControl>
//               <FormControl flex={{ base: "auto", md: 1 }}>
//                 <Select
//                   size="lg"
//                   placeholder="Location"
//                   onChange={handleLocationSelect}
//                   borderradius="lg"
//                   _focus={{ borderColor: accentColor, boxShadow: "none" }}
//                 >
//                   {coreLocation?.map((item) => (
//                     <option key={item.id} value={item.uuid}>
//                       {item.title}
//                     </option>
//                   ))}
//                 </Select>
//               </FormControl>
//               <Button
//                 size="lg"
//                 bg={accentColor}
//                 color="white"
//                 px={8}
//                 _hover={{ bg: hoverAccentColor }}
//                 onClick={categorizeAndSend}
//                 w={{ base: "full", md: "auto" }}
//               >
//                 Search
//               </Button>
//             </Flex>

//             {(selectedTitles.length > 0 || locations.length > 0) && (
//               <Wrap spacing={3} w="full">
//                 {selectedTitles.map((title) => (
//                   <WrapItem key={title}>
//                     <Tag size="lg" colorScheme="blue" borderradius="full">
//                       <TagLabel>{title}</TagLabel>
//                       <TagCloseButton onClick={() => removeTitle(title)} />
//                     </Tag>
//                   </WrapItem>
//                 ))}

//                 {locations.map((location) => (
//                   <WrapItem key={location}>
//                     <Tag size="lg" colorScheme="green" borderradius="full">
//                       <TagLabel>
//                         {coreLocation.find((loc) => loc.uuid === location)
//                           ?.title || location}
//                       </TagLabel>
//                       <TagCloseButton
//                         onClick={() => removeLocation(location)}
//                       />
//                     </Tag>
//                   </WrapItem>
//                 ))}
//               </Wrap>
//             )}
//           </VStack>
//         </Box>

//         {/* Popular Searches */}
//         {(!isSearched || isInputFocused) && response && response.length > 0 && (
//           <Box bg={bgColor} p={6} borderradius="xl" mb={8}>
//             <Heading as="h3" size="md" mb={4}>
//               Popular Searches:
//             </Heading>
//             <Wrap spacing={2}>
//               {response.map((suggestion, index) => (
//                 <WrapItem key={index}>
//                   <Button
//                     size="sm"
//                     variant="outline"
//                     onClick={() => handleSelect(suggestion.title)}
//                     colorScheme="blue"
//                   >
//                     {suggestion.title}
//                   </Button>
//                 </WrapItem>
//               ))}
//             </Wrap>
//           </Box>
//         )}

//         {/* Job Listings */}
//         <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={6}>
//           {isLoading ? (
//             <>
//               <JobListingSkeleton />
//               <JobListingSkeleton />
//               <JobListingSkeleton />
//               <JobListingSkeleton />
//             </>
//           ) : Array.isArray(result) && result.length > 0 ? (
//             result.map((jobItem) => (
//               <Box
//                 key={jobItem.uuid}
//                 borderWidth={1}
//                 borderradius="lg"
//                 overflow="hidden"
//                 boxShadow="md"
//                 bg={bgColor}
//                 _hover={{ boxShadow: "lg" }}
//                 transition="all 0.3s"
//               >
//                 <Flex p={6}>
//                   <Image
//                     src={
//                       "https://apusthemes.com/wp-demo/superio/wp-content/uploads/2021/05/y2.jpg"
//                     }
//                     alt="Company Logo"
//                     boxSize="16"
//                     objectFit="cover"
//                     borderradius="full"
//                     mr={4}
//                   />
//                   <Box flex={1}>
//                     <Heading as="h3" size="md" mb={1}>
//                       {jobItem.job_title?.title || jobItem.job_name}
//                     </Heading>
//                     <Text
//                       fontSize="sm"
//                       color="green.500"
//                       fontWeight="medium"
//                       mb={2}
//                     >
//                        {jobItem.job_company}
//                     </Text>
//                     <Text fontSize="sm" color="gray.600" mb={1}>
//                       <Text as="span" fontWeight="semibold">
//                         {jobItem.hiring_company_name}
//                       </Text>
//                       {jobItem.department?.title &&
//                         `, ${jobItem.department.title}`}
//                     </Text>
//                     <Text fontSize="sm" color="gray.600" mb={3}>
//                     <div className="card__body text-left font-semibold text-gray-500">
//                             {jobItem.salary_min_amount === null ||
//                             jobItem.salary_min_amount === 0
//                               ? "Not Disclosed"
//                               : `₹${jobItem.salary_min_amount || "N/A"} - ₹${
//                                 jobItem.salary_max_amount || "N/A"
//                                 } / ${jobItem.salary_per_type || "Not Specified"}`}
//                             {jobItem?.job_type || ""}
//                           </div>
//                     </Text>
//                     <Wrap spacing={2}>
//                       <WrapItem>
//                         <Badge
//                           colorScheme="blue"
//                           borderradius="full"
//                           px={2}
//                           py={1}
//                         >
//                           {jobItem.job_tag}abcd
//                         </Badge>
//                       </WrapItem>
//                     </Wrap>
//                   </Box>
//                   <Box>
//                     <Tooltip label="Bookmark">
//                       <IconButton
//                         aria-label="Bookmark job"
//                         icon={<StarIcon />}
//                         variant="ghost"
//                         colorScheme="blue"
//                       />
//                     </Tooltip>
//                   </Box>
//                 </Flex>
//                 <Divider />
//                 <Flex justifyContent="space-between" p={4}>
//                   <Link to={`/jobs/${jobItem.uuid}`}>
//                     <Button variant="outline" colorScheme="blue" size="sm">
//                       View Details
//                     </Button>
//                   </Link>
//                   <Link to={`/jobs/${jobItem.uuid}`}>
//                     <Button colorScheme="blue" size="sm">
//                       Apply Now
//                     </Button>
//                   </Link>
//                 </Flex>
//               </Box>
//             ))
//           ) : (
//             <Center w="full" py={10} gridColumn="1 / -1">
//               <VStack spacing={4}>
//                 <Text fontSize="xl" fontWeight="medium">
//                   No job results found
//                 </Text>
//                 <Text color="gray.600" textAlign="center">
//                   Try adjusting your search criteria or explore our job
//                   recommendations.
//                 </Text>
//               </VStack>
//             </Center>
//           )}
//         </SimpleGrid>
//       </Container>
//     </Box>
//   );
// }

// export default JobSearch;

"use client";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  Heading,
  Input,
  Select,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  VStack,
  Wrap,
  WrapItem,
  SimpleGrid,
  useColorModeValue,
  Image,
  Badge,
  InputGroup,
  InputLeftElement,
  Divider,
  IconButton,
  Tooltip,
  Center,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  GridItem,
  Grid,
  useToast,
} from "@chakra-ui/react";
import { SearchIcon, StarIcon } from "@chakra-ui/icons";
import { fetchSuggestionsAsync, selectSuggestions } from "./SuggestionsSlice";
import {
  fetchJobsByKeywordsAsync,
  selectJobsByKeywords,
  selectJobsByKeywordsTotal,
} from "../jobSearchByKeywordSlice.js/jobSearchByKeywordSlice";
import {
  fetchPublicCoreLocationsAsync,
  selectPublicCoreLocations,
} from "../FetchLocationSlice/FetchLocationSlice";
import { EMPLOYER_COMPANY_LOGO_SAVE_URL } from "../../common/URLs";
import companyLogo from "./logo1png.png";
import { NoDataFound } from "../../../pages/CommonPublicPages/Basic/NoDataFound";
import { fetchUserRole } from "../../common/FetchUserRole";
import { updateBookmarkAsync } from "../../candidateDashboard/candidateSlice/SavedJobs/SavedJobsSlice";
import { BriefcaseIcon, BuildingOffice2Icon, ClockIcon, CurrencyRupeeIcon } from "@heroicons/react/24/outline";
import { TimeDifference } from "../../common/TimeDifference";

const JobListingSkeleton = () => (
  <Box
    borderWidth={1}
    borderradius="lg"
    overflow="hidden"
    boxShadow="md"
    bg="white"
  >
    <Flex p={6}>
      <SkeletonCircle size="16" mr={4} />
      <Box flex={1}>
        <SkeletonText
          mt="4"
          noOfLines={1}
          spacing="4"
          skeletonHeight="3"
          width="70%"
        />
        <SkeletonText
          mt="4"
          noOfLines={1}
          spacing="4"
          skeletonHeight="2"
          width="50%"
        />
        <SkeletonText
          mt="4"
          noOfLines={1}
          spacing="4"
          skeletonHeight="2"
          width="60%"
        />
        <SkeletonText
          mt="4"
          noOfLines={1}
          spacing="4"
          skeletonHeight="2"
          width="40%"
        />
        <Wrap mt="4">
          <Skeleton height="24px" width="60px" />
          <Skeleton height="24px" width="60px" />
          <Skeleton height="24px" width="60px" />
        </Wrap>
      </Box>
    </Flex>
    <Divider />
    <Flex justifyContent="space-between" p={4}>
      <Skeleton height="32px" width="100px" />
      <Skeleton height="32px" width="100px" />
    </Flex>
  </Box>
);

function JobSearch() {
  const dispatch = useDispatch();
  const coreLocation = useSelector(selectPublicCoreLocations);
  const response = useSelector(selectSuggestions);
  const results = useSelector(selectJobsByKeywords);
  const totalJobs = useSelector(selectJobsByKeywordsTotal);
  console.log("totalJobs", totalJobs);

  const jobsPerPage = 15; // Number of jobs per page
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(totalJobs / jobsPerPage);

  // Pagination handlers
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // const [keyword, setKeyword] = useState("");
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [experience, setExperience] = useState("");
  // const [locations, setLocations] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const initialKeyword = location.state?.keyword || "";
  const initialLocationUUID = location.state?.locationUUID || "";

  const [keyword, setKeyword] = useState(initialKeyword);
  const [locations, setLocations] = useState(
    initialLocationUUID ? [initialLocationUUID] : []
  );

  useEffect(() => {
    if (initialLocationUUID && !locations.includes(initialLocationUUID)) {
      setLocations((prevLocations) => [...prevLocations, initialLocationUUID]);
    }
  }, [initialLocationUUID, locations]); // Empty dependency array means this effect runs once when the component mounts
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state) {
      let currentExperience = experience;
      let currentLocations = [...locations];

      if (location.state.keyword) {
        setKeyword(location.state.keyword);
      }

      if (location.state.experience) {
        currentExperience = location.state.experience;
        setExperience(currentExperience);
      }

      // Set locations from state (ensure it's an array)
      if (Array.isArray(location.state.selectedLocations)) {
        currentLocations = [...currentLocations];
        location.state.selectedLocations.forEach((loc) => {
          if (!currentLocations.includes(loc)) {
            currentLocations.push(loc);
          }
        });
        setLocations(currentLocations);
      }

      // Set selected titles from incoming suggestions
      if (
        location.state.selectedSuggestions &&
        Array.isArray(location.state.selectedSuggestions)
      ) {
        const titles = location.state.selectedSuggestions.map(
          (suggestion) => suggestion.title
        );
        setSelectedTitles((prevTitles) => {
          const newTitles = [...prevTitles];
          titles.forEach((title) => {
            if (!newTitles.includes(title)) {
              newTitles.push(title);
            }
          });
          return newTitles;
        });
      }

      // Prepare the search payload with all available filters
      const payload = {
        ...(currentExperience ? { experience: currentExperience } : {}),
        ...(currentLocations.length > 0 ? { locations: currentLocations } : {}),
        ...(location.state.skills && location.state.skills.length > 0
          ? { skills: location.state.skills }
          : {}),
        ...(location.state.titles && location.state.titles.length > 0
          ? { titles: location.state.titles }
          : {}),
        ...(location.state.company && location.state.company.length > 0
          ? { company: location.state.company }
          : {}),
      };

      // Only search if we have any filters
      if (Object.keys(payload).length > 0) {
        // Use a timeout to ensure state updates have been processed
        setTimeout(() => {
          setIsLoading(true);
          dispatch(fetchJobsByKeywordsAsync(payload))
            .unwrap() // Make sure to handle the promise correctly
            .then((responseData) => {
              setIsLoading(false);
              setIsSearched(true);
              setIsInputFocused(false);
              console.log("resp", responseData);
              setResult(responseData?.jobs);
            })
            .catch((error) => {
              console.error("Search error:", error);
              setIsLoading(false);
            });
        }, 50);
      }

      // Clear state after use with sufficient delay
      setTimeout(() => {
        navigate("/job-search", { replace: true, state: null });
      }, 300);
    }
  }, [location.state]); // Only depend on location.state to prevent re-runs

  useEffect(() => {
    dispatch(fetchPublicCoreLocationsAsync());
    if (keyword) {
      dispatch(fetchSuggestionsAsync({ keyword }));
    }
  }, [keyword, dispatch]);

  const handleLocationSelect = (e) => {
    const selectedLocation = e.target.value;
    if (selectedLocation && !locations.includes(selectedLocation)) {
      setLocations((prevLocations) => [...prevLocations, selectedLocation]);
    }
    setIsSearched(false);
  };

  const handleChange = (e) => {
    setKeyword(e.target.value);
    setIsSearched(false);
    // Optionally, you can save the updated keyword to localStorage on change
    localStorage.setItem("keyword", e.target.value);
  };

  const handleSelect = (title) => {
    if (!selectedTitles.includes(title)) {
      setSelectedTitles([...selectedTitles, title]);
    }
  };

  const handleExperienceChange = (e) => {
    setExperience(e.target.value);
    setIsSearched(false);
  };

  const removeLocation = (location) => {
    setLocations(locations.filter((loc) => loc !== location));
  };

  const removeTitle = (title) => {
    setSelectedTitles(selectedTitles.filter((t) => t !== title));
  };

  const findJsUuids = () => {
    return response
      .filter(
        (item) =>
          item.uuid.startsWith("js") && selectedTitles.includes(item.title)
      )
      .map((item) => item.uuid.replace(/^js_/, ""));
  };

  const findJtUuids = () => {
    return response
      .filter(
        (item) =>
          item.uuid.startsWith("jt") && selectedTitles.includes(item.title)
      )
      .map((item) => item.uuid.replace(/^jt_/, ""));
  };

  const findCnUuids = () => {
    return response
      .filter(
        (item) =>
          item.uuid.startsWith("cn") && selectedTitles.includes(item.title)
      )
      .map((item) => item.uuid.replace(/^cn_/, "")); // Remove 'cn_' prefix
  };
  const [result, setResult] = useState([]); // Store search results

  const categorizeAndSend = () => {
    setResult([]); // Clear previous results
    const jsUuids = findJsUuids(); // Skill UUIDs
    const jtUuids = findJtUuids(); // Title UUIDs
    const cnUuids = findCnUuids(); // Company UUIDs with 'cn_' prefix removed

    // Only include non-empty fields in the payload
    const payload = {
      ...(experience ? { experience } : {}),
      ...(locations.length ? { locations } : {}),
      ...(jsUuids.length ? { skills: jsUuids } : {}),
      ...(jtUuids.length ? { titles: jtUuids } : {}),
      ...(cnUuids.length ? { company: cnUuids } : {}),
    };

    // Ensure at least one filter is applied
    if (Object.keys(payload).length === 0) {
      console.log("No filters applied. Please select at least one condition.");
      return;
    }

    setIsLoading(true);

    dispatch(fetchJobsByKeywordsAsync(payload))
      .then((response) => {
        setIsLoading(false);
        setIsSearched(true);
        setIsInputFocused(false);

        // Assuming the response contains the results you want to display
        const jobs = response?.payload?.jobs; // Adjust this if your response structure is different
        setResult(jobs); // Set the new jobs list
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  
    const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  
    const [appliedJobs, setAppliedJobs] = useState({});
  
    // Prefill applied jobs state when jobs are loaded
    useEffect(() => {
      if (result?.length > 0) {
        const initialAppliedJobs = {};
        result.forEach((job) => {
          initialAppliedJobs[job.uuid] = job.candidate_job_apply_count === 1;
        });
        setAppliedJobs(initialAppliedJobs);
      }
      // window.scrollTo(0, 0);
    }, [result]);
  
    // Prefill bookmark state when jobs are loaded
    useEffect(() => {
      if (result?.length > 0) {
        const initialBookmarks = {};
        result.forEach((job) => {
          initialBookmarks[job.uuid] = job.candidate_job_saved_count
            ? true
            : false;
        });
        setBookmarkedJobs(initialBookmarks);
      }
      // window.scrollTo(0, 0);
    }, [result]); // Run when jobs updates
  
    const toast = useToast();
  
    const handleBookmarkClick = async (jobId) => {
      // First check the role and handle redirection if needed
      try {
        // Convert the callback-based fetchUserRole to a Promise
        const role = await new Promise((resolve, reject) => {
          fetchUserRole((role) => {
            resolve(role);
          });
        });
  
        // If not a candidate, redirect and exit the function
        if (role !== "candidate") {
  
          toast({
            title: "Please login first",
            description: "You need to login as a candidate to save or apply for a job.",
            status: "warning",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
          navigate("/login");
          return; // Important: stop execution here
        }
  
        // Only proceed with bookmark if user is a candidate
        const isCurrentlyBookmarked = bookmarkedJobs[jobId]; // Check current status
        const newStatus = isCurrentlyBookmarked ? "remove" : "save"; // Toggle between "save" and "remove"
  
        // Optimistic UI update
        setBookmarkedJobs((prev) => ({
          ...prev,
          [jobId]: !isCurrentlyBookmarked,
        }));
  
        await dispatch(
          updateBookmarkAsync({ job_uuid: jobId, status: newStatus })
        );
  
        // Show success toast
        toast({
          title: `Job ${newStatus === "save" ? "saved" : "removed"
            } successfully!`,
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      } catch (error) {
        console.error("Failed to update bookmark:", error);
  
        // Revert on failure - only if we got past the role check
        if (bookmarkedJobs[jobId] !== undefined) {
          setBookmarkedJobs((prev) => ({
            ...prev,
            [jobId]: !prev[jobId], // Revert to previous state
          }));
        }
  
        // Show error toast
        toast({
          title: "Failed to update bookmark.",
          description: "Something went wrong. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      }
    };

  // Function to render job content based on loading and data state
    const renderJobContent = () => {
      if (isLoading) {
        // Show skeleton loader when data is being fetched
        return Array.from({ length: 4 }).map((_, index) => (
          <GridItem key={index}>
            <Box
              borderWidth={1}
              borderRadius="lg"
              p={6}
              bg="white"
              boxShadow="md"
            >
              <Flex>
                <SkeletonCircle size="60px" mr={4} />
                <Box flex={1}>
                  <SkeletonText
                    mt="4"
                    noOfLines={4}
                    spacing="4"
                    skeletonHeight="2"
                  />
                </Box>
              </Flex>
            </Box>
          </GridItem>
        ));
      } else if (!Array.isArray(result) || result.length === 0) {
        // Show NoDataFound component when there's no data
        return (
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <div>
              <NoDataFound
                title="No Job Listings Found"
                message="We couldn't find any job listings at the moment. Please check back later or try different search criteria."
              />
            </div>
          </GridItem>
        );
      } else {
        // Show actual job data
        return result.map((job) => (
          <GridItem key={job.uuid}>
            <Box
              borderWidth={1}
              borderRadius="lg"
              bg="white"
              // boxShadow="md"
              _hover={{ transform: "translateY(-2px)" }}
              transition="all 0.2s"
              overflow="hidden"
            >
              <Flex p={6}>
                <Box flexShrink={0} mr={4}>
                  <Image
                    // src={`${EMPLOYER_COMPANY_LOGO_SAVE_URL}${job.company_logo}`}
                    src={
                      job.company_logo
                        ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${job.company_logo}`
                        : companyLogo
                    }
                    name={job.name}
                    className="h-16 w-16 object-cover rounded-full"
                    // alt={company.company_name || "Company Logo"}
                    // className="h-16 w-auto object-contain"
                    onError={(e) => (e.target.src = companyLogo)}
                  />
                </Box>
                <Box flex={1}>
                  <Link to={`/jobs/${job.uuid}`}>
                    <div
                      fontSize="xl"
                      fontWeight="bold"
                      mb={1}
                      className="text-black font-semibold text-xl flex-wrap flex items-center "
                    >
                      {job?.job_title?.title
                        ? job?.job_title?.title
                        : job.job_name}
  
                      <Badge colorScheme="blue" className="ml-2">
                        {job.job_tag}
                      </Badge>
                    </div>
                    <Text color="gray.600" fontSize="sm" mb={1}>
                      <span className="text-blue-600 font-medium">
                        <strong>{job?.company_name || "Company name NA"}</strong>
                      </span>
                      <span className="flex items-center gap-1">
                        {" "}
                        <BuildingOffice2Icon className="w-4 h-4  text-zinc-500" />
                        {job?.department?.title || "Job Department Name NA"}
                      </span>
                    </Text>
                    <Text color="gray.600" fontSize="sm" mb={1}>
                      <div className=" text-left font-normal text-gray-500 ">
                        <div className="flex items-center gap-1">
                          {" "}
                          <CurrencyRupeeIcon className="w-4 h-4 text-zinc-500" />
                          {job.salary_min_amount === null ||
                            job.salary_min_amount === 0
                            ? "Not Disclosed"
                            : `₹${job.salary_min_amount || "N/A"} - ₹${job.salary_max_amount || "N/A"
                            } / ${job.salary_per_type || "Not Specified"}`}
                        </div>
  
                        <span className="flex items-center gap-1">
                          <BriefcaseIcon className="w-4 h-4  text-zinc-500" />
                          {job.job_type || "Job Type NA"}
                        </span>
                      </div>
                    </Text>
                    <Text
                      color="gray.600"
                      fontSize="sm"
                      mb={1}
                      className="flex items-center gap-1"
                    >
                      <ClockIcon className="w-4 h-4  text-zinc-500" />
                      <TimeDifference dateTimeString={job.created_at} />
                    </Text>
                  </Link>
                </Box>
  
                {/* Bookmark Icon */}
                <div className="flex flex-col items-end justify-between">
                  <button
                    onClick={() => handleBookmarkClick(job.uuid)}
                    className="bookmark"
                  >
                    {bookmarkedJobs[job.uuid] ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="black"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 3C4.9 3 4 3.9 4 5V21L12 16.5L20 21V5C20 3.9 19.1 3 18 3H6Z"
                          stroke="black"
                          strokeWidth="2"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 3C4.9 3 4 3.9 4 5V21L12 16.5L20 21V5C20 3.9 19.1 3 18 3H6Z"
                          stroke="black"
                          strokeWidth="2"
                        />
                      </svg>
                    )}
                  </button>
                  {appliedJobs[job.uuid] && (
                    <span className="text-green-600 text-sm font-semibold flex items-center gap-1">
                      ✅ Applied
                    </span>
                  )}
                </div>
              </Flex>
            </Box>
          </GridItem>
        ));
      }
    };

  console.log("result", result);

  const bgColor = useColorModeValue("white", "gray.800");
  const accentColor = "blue.500";
  const hoverAccentColor = "blue.600";

  return (
    <Box bg="gray.50" minH="100vh">
      {/* <Dummy /> */}
      <Container maxW="8xl" py={8}>
        {/* Header Section */}
        <Box
          position="relative"
          mb={8}
          borderradius="xl"
          overflow="hidden"
          p={8}
          style={{
            background:
              "linear-gradient(340deg, rgba(119, 161, 211, 0.2),rgba(121, 203, 202,0.1),rgba(254, 234, 234, 1))",
          }}
        >
          <Flex
            position="relative"
            zIndex={1}
            justifyContent="space-between"
            alignItems="center"
          >
            <VStack align="flex-start" spacing={2}>
              <Heading
                as="h1"
                size={{ base: "xl", md: "2xl" }}
                color="gray.800"
                maxW="xl"
                className="text-left"
              >
                Find Your <span className="text-fontBlue">Dream Job</span> Here
              </Heading>
              <Text color="gray.600" fontSize="lg">
                Discover opportunities that match your career goals
              </Text>
            </VStack>
          </Flex>
        </Box>

        {/* Search Section */}
        <Box bg={bgColor} p={6} borderradius="xl" boxShadow="sm" mb={8}>
          <VStack spacing={6}>
            <Flex
              gap={4}
              w="full"
              flexDirection={{ base: "column", md: "row" }}
            >
              <InputGroup size="lg" flex={{ base: "auto", md: 2 }}>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input
                  placeholder="Job title or keyword"
                  value={keyword}
                  onChange={handleChange}
                  onFocus={() => setIsInputFocused(true)}
                  borderradius="lg"
                  _focus={{ borderColor: accentColor, boxShadow: "none" }}
                />
              </InputGroup>
              <FormControl flex={{ base: "auto", md: 1 }}>
                <Select
                  size="lg"
                  placeholder="Experience"
                  value={experience}
                  onChange={handleExperienceChange}
                  borderradius="lg"
                  _focus={{ borderColor: accentColor, boxShadow: "none" }}
                >
                  {Array.from({ length: 30 }, (_, i) => i + 1).map((year) => (
                    <option key={year} value={year}>
                      {year} {year > 1 ? "Years" : "Year"}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={{ base: "auto", md: 1 }}>
                <Select
                  size="lg"
                  placeholder="Location"
                  onChange={handleLocationSelect}
                  borderradius="lg"
                  _focus={{ borderColor: accentColor, boxShadow: "none" }}
                >
                  {coreLocation?.map((item) => (
                    <option key={item.id} value={item.uuid}>
                      {item.title}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Button
                size="lg"
                bg={accentColor}
                color="white"
                px={8}
                _hover={{ bg: hoverAccentColor }}
                onClick={categorizeAndSend}
                w={{ base: "full", md: "auto" }}
              >
                Search
              </Button>
            </Flex>

            {(selectedTitles.length > 0 || locations.length > 0) && (
              <Wrap spacing={3} w="full">
                {selectedTitles.map((title) => (
                  <WrapItem key={title}>
                    <Tag size="lg" colorScheme="blue" borderradius="full">
                      <TagLabel>{title}</TagLabel>
                      <TagCloseButton onClick={() => removeTitle(title)} />
                    </Tag>
                  </WrapItem>
                ))}

                {locations.map((location) => (
                  <WrapItem key={location}>
                    <Tag size="lg" colorScheme="green" borderradius="full">
                      <TagLabel>
                        {coreLocation.find((loc) => loc.uuid === location)
                          ?.title || location}
                      </TagLabel>
                      <TagCloseButton
                        onClick={() => removeLocation(location)}
                      />
                    </Tag>
                  </WrapItem>
                ))}
              </Wrap>
            )}
          </VStack>
        </Box>

        {/* Popular Searches */}
        {(!isSearched || isInputFocused) && response && response.length > 0 && (
          <Box bg={bgColor} p={6} borderradius="xl" mb={8}>
            <Heading as="h3" size="md" mb={4}>
              Popular Searches:
            </Heading>
            <Wrap spacing={2}>
              {response.map((suggestion, index) => (
                <WrapItem key={index}>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleSelect(suggestion.title)}
                    colorScheme="blue"
                  >
                    {suggestion.title}
                  </Button>
                </WrapItem>
              ))}
            </Wrap>
          </Box>
        )}

        {/* Job Listings */}
        {/* <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={6}>
          {isLoading ? (
            <>
              <JobListingSkeleton />
              <JobListingSkeleton />
              <JobListingSkeleton />
              <JobListingSkeleton />
            </>
          ) : Array.isArray(result) && result.length > 0 ? (
            result.map((jobItem) => (
              <Box
                key={jobItem.uuid}
                borderWidth={1}
                borderradius="lg"
                overflow="hidden"
                boxShadow="md"
                bg={bgColor}
                _hover={{ boxShadow: "lg" }}
                transition="all 0.3s"
              >
                <Flex p={6}>
                  <Image
                    src={
                      result.company_logo
                        ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${result.company_logo}`
                        : companyLogo
                    }
                    name={result.name}
                    className="h-16 w-16 object-cover rounded-full"
                    onError={(e) => (e.target.src = companyLogo)}
                  />
                  <Box flex={1}>
                    <Heading as="h3" size="md" mb={1}>
                      {jobItem.job_title?.title || jobItem.job_name}
                    </Heading>
                    <Text
                      fontSize="sm"
                      color="green.500"
                      fontWeight="medium"
                      mb={2}
                    >
                      {jobItem.job_company}
                    </Text>
                    <Text fontSize="sm" color="gray.600" mb={1}>
                      <Text as="span" fontWeight="semibold">
                        {jobItem.hiring_company_name}
                      </Text>
                      {jobItem.department?.title &&
                        `, ${jobItem.department.title}`}
                    </Text>
                    <Text fontSize="sm" color="gray.600" mb={3}>
                      <div className="card__body text-left font-semibold text-gray-500">
                        {jobItem.salary_min_amount === null ||
                        jobItem.salary_min_amount === 0
                          ? "Not Disclosed"
                          : `₹${jobItem.salary_min_amount || "N/A"} - ₹${
                              jobItem.salary_max_amount || "N/A"
                            } / ${jobItem.salary_per_type || "Not Specified"}`}
                        {jobItem?.job_type || ""}
                      </div>
                    </Text>
                    <Wrap spacing={2}>
                      <WrapItem>
                        <Badge
                          colorScheme="blue"
                          borderradius="full"
                          px={2}
                          py={1}
                        >
                          {jobItem.job_tag}
                        </Badge>
                      </WrapItem>
                    </Wrap>
                  </Box>
                  <Box>
                    <Tooltip label="Bookmark">
                      <IconButton
                        aria-label="Bookmark job"
                        icon={<StarIcon />}
                        variant="ghost"
                        colorScheme="blue"
                      />
                    </Tooltip>
                  </Box>
                </Flex>
                <Divider />
                <Flex justifyContent="space-between" p={4}>
                  <Link to={`/jobs/${jobItem.uuid}`}>
                    <Button variant="outline" colorScheme="blue" size="sm">
                      View Details
                    </Button>
                  </Link>
                  <Link to={`/jobs/${jobItem.uuid}`}>
                    <Button colorScheme="blue" size="sm">
                      Apply Now
                    </Button>
                  </Link>
                </Flex>
              </Box>
            ))
          ) : (
            <Center w="full" py={10} gridColumn="1 / -1">
              <VStack spacing={4}>
                <Text fontSize="xl" fontWeight="medium">
                  No job results found
                </Text>
                <Text color="gray.600" textAlign="center">
                  Try adjusting your search criteria or explore our job
                  recommendations.
                </Text>
              </VStack>
            </Center>
          )}
        </SimpleGrid> */}

        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={3}>
          {renderJobContent()}
        </Grid>

        <GridItem colSpan={2} display="flex" justifyContent="center">
          <div className="flex w-full justify-evenly items-center mt-4">
            <button
              className={`bg-gray-300 text-black px-4 py-2 rounded ${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              className={`bg-blue-500 text-white px-4 py-2 rounded ${
                currentPage === totalPages
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </GridItem>
      </Container>
    </Box>
  );
}

export default JobSearch;
